import { ApiAccountStatus, ApiNote } from '../api/_legacy/generated-api'
import { TradeActivationStep } from '../modules/tradebuilder-v2/types'
import { unpascal } from '../modules/tradebuilder-v2/util'

export function accountStatusToStep(s: ApiAccountStatus): TradeActivationStep {
  switch (s) {
    case 'Draft':
      return TradeActivationStep.draft
    case 'Rejected':
      return TradeActivationStep.rejected
    case 'Expired':
      return TradeActivationStep.expired
    case 'PendingEconomicsApproval':
      return TradeActivationStep.setEconomics
    case 'PendingApproval':
      return TradeActivationStep.approve
    case 'PendingCommitment':
      return TradeActivationStep.commitment
    case 'PendingClientCommitment':
      return TradeActivationStep.clientCommitment
    case 'PendingSettlement':
      return TradeActivationStep.settlement
    case 'PendingActivation':
      return TradeActivationStep.activate
    case 'Active':
    case 'Activating':
      return TradeActivationStep.active
    case 'Inactive':
      return TradeActivationStep.inactive
    default:
      return TradeActivationStep.submit
  }
}

export function accountStepToDisplayName(step: TradeActivationStep) {
  switch (step) {
    case TradeActivationStep.draft:
      return 'Draft'
    case TradeActivationStep.rejected:
      return 'Rejected'
    case TradeActivationStep.expired:
      return 'Expired'
    case TradeActivationStep.deleted:
      return 'Deleted'
    case TradeActivationStep.submit:
      return 'Submit'
    case TradeActivationStep.setEconomics:
      return 'Pending economics approval'
    case TradeActivationStep.approve:
      return 'Pending approval'
    case TradeActivationStep.commitment:
      return 'Pending business unit commitment'
    case TradeActivationStep.clientCommitment:
      return 'Pending client commitment'
    case TradeActivationStep.settlement:
      return 'Pending settlement'
    case TradeActivationStep.activate:
      return 'Pending activation'
    case TradeActivationStep.active:
      return 'Activating'
    case TradeActivationStep.inactive:
      return 'Inactive'
  }
}

export function getNoteCollateralMessage(step: TradeActivationStep, note: ApiNote): string {
  if (!note?.isCollateralForLoan) return ''
  switch (step) {
    case TradeActivationStep.setEconomics:
    case TradeActivationStep.approve:
    case TradeActivationStep.commitment:
    case TradeActivationStep.clientCommitment:
    case TradeActivationStep.settlement:
    case TradeActivationStep.activate:
    case TradeActivationStep.active:
      return '(Note: This trade belongs to a note which is used as collateral for a loan)'
    default:
      return ''
  }
}

export function formatAccountStatusToDisplayName(s: ApiAccountStatus): string {
  switch (s) {
    case 'Draft':
      return 'Draft'
    case 'Rejected':
      return 'Rejected'
    case 'Expired':
      return 'Expired'
    case 'PendingApproval':
      return 'Pending approval'
    case 'PendingCommitment':
      return 'Pending business unit commitment'
    case 'PendingClientCommitment':
      return 'Pending client commitment'
    case 'PendingSettlement':
      return 'Pending settlement'
    case 'PendingActivation':
      return 'Pending activation'
    case 'Active':
      return 'Activating'
    case 'Inactive':
      return 'Inactive'
    case 'Deleted':
      return 'Deleted'
    default:
      return unpascal(s)
  }
}

export const getBannerStateFromTradeStatuStep = (
  status: TradeActivationStep
): 'disabled' | 'success' | 'warning' => {
  switch (status) {
    case TradeActivationStep.active:
      return 'success'
    case TradeActivationStep.draft:
      return 'disabled'
    default:
      return 'warning'
  }
}

export const getBannerStateFromTradeStatus = (
  status: string | undefined
): 'disabled' | 'success' | 'warning' => {
  switch (status) {
    case 'Activating':
      return 'success'
    case 'Draft':
      return 'disabled'
    default:
      return 'warning'
  }
}
